export function careersSlider() {
    $(".careers-slider").each(function () {
        $(this).slick({
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 15000,
            pauseOnHover: false,
            variableWidth: true,
            cssEase: 'linear'
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/careersSlider.js